import React, { useState } from "react";
import { Link } from "react-router-dom";

// slider
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

const MarketMobile = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="h-[80vh] lg:hidden">
      <Swiper
        className="partnerSwipper h-[80vh] w-full"
        spaceBetween={0}
        slidesPerView={1.3}
        navigation={{
          clickable: true,
        }}
        speed={1000}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]}
        breakpoints={{
          578: {
            slidesPerView: 3,
            slidesPerGroup: 4,
          },
          768: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {data?.map(({ image, name, description }, index) => (
          <SwiperSlide
            key={index}
            className="h-[80vh] w-full flex items-center"
          >
            <Link className=" group  h-[80vh] w-full relative" key={index}>
              <div className="absolute w-full h-[40vh] bottom-0 left-0 z-[10] bg-gradient-to-t from-[#0000008c] to-transparent"></div>

              <img
                className={`${
                  activeIndex === index ? "grayscale-0" : "grayscale"
                } h-[79vh] w-full transition-all duration-700`}
                src={image}
                alt={name}
              />
              {/* overlay */}
              <div
                className={`overlay absolute top-0 left-0 w-full h-full transition-transform duration-700 ${
                  activeIndex === index
                    ? "translate-y-[-100%]"
                    : "translate-y-0"
                } bg-[#0000009a] z-[0]`}
              ></div>
              {/* content */}
              <div className="absolute left-6 bottom-16 w-full z-[100]">
                <h4 className="text-white text-4xl font-bold">{name}</h4>
                <div
                  className={`text-white mt-2 bg-[#000000a4]  text-lg transition ease-in duration-500 p-4 w-max ${
                    activeIndex === index
                      ? "translate-y-0 h-auto opacity-100"
                      : "translate-y-[200%] h-0 opacity-0"
                  }`}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default MarketMobile;
